// require('../third/leaflet-routing-machine');
// import {createControlComponent} from '@react-leaflet/core';
import {useEffect} from 'react';
import {useMap} from 'react-leaflet';
import L from 'leaflet';
// import 'leaflet-routing-machine/dist/leaflet-routing-machine.css';
import '../dist/leaflet-routing-machine';
// import 'leaflet/dist/leaflet.css';
// @ts-ignore
// eslint-disable-next-line no-restricted-globals
import markerParking from '../assets/icons/marker_parking.svg';
// import './localization';

let MarkerParkingIcon = L.icon({
	iconUrl: markerParking,
	// iconRetinaUrl: markerRetina,
	// shadowUrl: markerShadow
	iconSize: [30, 30]
});

const RoutineMachine = (props: { locations: any; }) => {
	const {locations} = props;
	
	const map = useMap();
	// @ts-ignore
	useEffect(() => {
		if (!map) return;
		// @ts-ignore
		const routingControl = L.Routing.control({
			// @ts-ignore
			waypoints: [
				L.latLng(locations.start),
				L.latLng(locations.stop)
			],
			// router: new L.Routing.Google(),
			routeWhileDragging: false,
			addWaypoints: true,
			draggableWaypoints: false,
			fitSelectedRoutes: true,
			showAlternatives: true,
			useZoomParameter: true,
			collapsible: true,
			language: 'fa',
			// itineraryFormatter: "div",
			autoRoute: true,
			// @ts-ignore
			lineOptions: {
				styles: [{color: '#539fe5', weight: 6, opacity: 1}]
			},
			// @ts-ignore
			altLineOptions: {
				styles: [{color: '#000', weight: 4, opacity: 0.5}]
			},
			// createMarker: function (i: number, waypoints: any, n: number) {
			// 	if (i === 0) {
			// 		// marker_icon = icon.startIcon;
			// 		marker_icon = MarkerParkingIcon;
			// 	}
			//
			// 	var marker_icon;
			// 	if (i === 0) {
			// 		// marker_icon = icon.startIcon;
			// 		marker_icon = MarkerParkingIcon;
			// 	} else if (i == n - 1) {
			// 		// marker_icon = icon.endIcon
			// 		marker_icon = MarkerParkingIcon;
			// 	}
			// 	var marker = L.marker(i === 0 ? L.latLng(36.2884, 59.6157) : L.latLng(36.29512936, 59.60121095), {
			// 		draggable: false,
			// 		icon: marker_icon
			// 	});
			// 	return marker;
			// },
			// createMarker: (i: number) => {
			// 	return L.marker(i === 0 ? L.latLng(36.2884, 59.6157) : L.latLng(36.29512936, 59.60121095), {
			// 		draggable: false,
			// 		icon: MarkerParkingIcon
			// 	});
			// },
			createMarker: () => {
				return null;
			},
			show: false
		})
			.on('routingstart', () => {
				// console.log('routing start');
			})
			.on('routesfound', () => {
				// console.log('routes found');
			})
			.on('routingerror', () => {
				// console.log('routes error');
			})
			.addTo(map);
		let routingControlContainer = routingControl.getContainer();
		let controlContainerParent = routingControlContainer!.parentNode;
		// @ts-ignore
		controlContainerParent!.removeChild(routingControlContainer);
		let itineraryDiv = document.getElementById('path-results');
		// @ts-ignore
		itineraryDiv!.appendChild(routingControlContainer);
		return () => map.removeControl(routingControl);
	}, [map]);
	
	return (
		<></>
	);
};
export default RoutineMachine;
